import { defineField, defineType } from "sanity";

export const inStorePage = defineType({
  name: "inStorePage",
  title: "In Store Page",
  type: "document",
  groups: [
    { name: "content", title: "Content", default: true },
    { name: "seo", title: "SEO" }
  ],
  fields: [
    defineField({
      name: "header",
      title: "Header",
      type: "string",
      description: "Main heading for the In Store page.",
      group: "content"
    }),
    defineField({
      name: "body",
      title: "Body",
      type: "array",
      description: "Main copy for the In Store page. Highlight text and use the link button to add links.",
      of: [
        {
          type: "block",
          styles: [{ title: "Normal", value: "normal" }],
          lists: [],
          marks: {
            decorators: [
              { title: "Bold", value: "strong" },
              { title: "Italic", value: "em" }
            ],
            annotations: [
              {
                name: "link",
                type: "object",
                title: "Link",
                fields: [
                  defineField({
                    name: "href",
                    title: "URL",
                    type: "url",
                    validation: (Rule) =>
                      Rule.uri({ scheme: ["http", "https", "mailto", "tel"] })
                  })
                ]
              }
            ]
          }
        }
      ],
      group: "content"
    }),
    defineField({
      name: "gallery",
      title: "Gallery",
      type: "array",
      description: "Photos shown in the slideshow at the bottom of the In Store page.",
      of: [
        {
          type: "image",
          options: { hotspot: true },
          fields: [
            defineField({
              name: "alt",
              title: "Alt text",
              type: "string",
              description: "Describe the image for screen readers."
            })
          ]
        }
      ],
      group: "content"
    }),
    defineField({
      name: "metaTitle",
      title: "Meta title",
      type: "string",
      description: "Page title for search engines (e.g. 'In Store | Vault 88').",
      group: "seo"
    }),
    defineField({
      name: "metaDescription",
      title: "Meta description",
      type: "text",
      rows: 3,
      description: "Short description for search engines.",
      group: "seo"
    }),
    defineField({
      name: "ogImage",
      title: "Sharing image",
      type: "image",
      description: "Image shown when this page is shared on social media.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "seo"
    })
  ],
  preview: {
    prepare: () => ({
      title: "In Store Page"
    })
  }
});
